"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _actions = require("../../../actions");
function syncedBrandingSettings(_ref, _ref2) {
  var dispatch = _ref.dispatch;
  var brandingSettings = _ref2.brandingSettings;
  dispatch((0, _actions.syncBrandingSettings)(brandingSettings));
}
var _default = exports["default"] = syncedBrandingSettings;